"use client";

import { useCookieConsent } from "@/hooks/useCookieConsent";
import { motion, AnimatePresence } from "framer-motion";

export function CookieConsent() {
	const { showBanner, acceptCookies, declineCookies } = useCookieConsent();

	const buttonBase: React.CSSProperties = {
		height: "40px",
		borderRadius: "6px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "8px",
		cursor: "pointer",
		fontFamily: "var(--typography-family-body, Lexend)",
		fontSize: "14px",
		fontWeight: 300,
	};

	return (
		<AnimatePresence>
			{showBanner && (
				<motion.div
					initial={{ opacity: 0, y: 100 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: 100 }}
					transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
					className="fixed bottom-0 left-0 right-0 z-[200] bg-white border-t border-[#D4D4D4]"
				>
					{/* Desktop */}
					<div
						className="hidden sm:flex max-w-[1440px] mx-auto px-6 items-center justify-between gap-4"
						style={{ height: "121.354px" }}
					>
						<div className="flex-1">
							<h3
								className="mb-1"
								style={{
									color: "#000",
									fontFamily: "var(--typography-family-heading, Lexend)",
									fontSize: "20px",
									fontWeight: 300,
									lineHeight: "120%",
								}}
							>
								Consent to cookies, not to overpaying.
							</h3>
							<p
								style={{
									color: "#525252",
									fontFamily: "var(--typography-family-body, Lexend)",
									fontSize: "16px",
									fontWeight: 300,
									lineHeight: "120%",
								}}
							>
								We use cookies to enhance your experience and analyse traffic
							</p>
						</div>
						<div className="flex items-center gap-2 shrink-0">
							<button
								onClick={declineCookies}
								style={{
									...buttonBase,
									width: "137px",
									border: "1px solid #D4D4D4",
									background: "#fff",
									color: "#000",
								}}
								aria-label="Decline cookies"
							>
								Decline
							</button>
							<button
								onClick={acceptCookies}
								style={{
									...buttonBase,
									width: "137px",
									background: "var(--button-bg-primary, #040404)",
									color: "var(--button-text-primary, hsla(65, 94%, 72%, 1))",
									border: "none",
								}}
								aria-label="Accept cookies"
							>
								Accept
							</button>
						</div>
					</div>

					{/* Mobile */}
					<div
						className="flex sm:hidden flex-col justify-center px-4 gap-3"
						style={{ height: "179px" }}
					>
						<div>
							<h3
								className="mb-1"
								style={{
									color: "#000",
									fontFamily: "var(--typography-family-body, Lexend)",
									fontSize: "16px",
									fontWeight: 300,
									lineHeight: "120%",
								}}
							>
								Consent to cookies, not to overpaying.
							</h3>
							<p
								style={{
									color: "#525252",
									fontFamily: "var(--typography-family-body, Lexend)",
									fontSize: "13px",
									fontWeight: 300,
									lineHeight: "150%",
								}}
							>
								We use cookies to enhance your experience and analyse traffic
							</p>
						</div>
						<div className="flex items-center gap-2 mt-4">
							<button
								onClick={declineCookies}
								style={{
									...buttonBase,
									flex: 1,
									border: "1px solid #D4D4D4",
									background: "#fff",
									color: "#000",
								}}
								aria-label="Decline cookies"
							>
								Decline
							</button>
							<button
								onClick={acceptCookies}
								style={{
									...buttonBase,
									flex: 1,
									background: "var(--button-bg-primary, #040404)",
									color: "var(--button-text-primary, hsla(65, 94%, 72%, 1))",
									border: "none",
								}}
								aria-label="Accept cookies"
							>
								Accept
							</button>
						</div>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
